import { IRequestCalloutEventDTO } from './types/IRequestCalloutDTOs'
import ICalloutRequestedStep from './types/ICalloutRequestedStep'
import { intervalToDuration, min, isDate, addSeconds } from 'date-fns';
import { createCalloutSteps } from './calloutRequestedData';
import { IVehicleLocation } from '../../../common/types';
import CalloutStatuses from '../types/CalloutStatuses';

const convertToDate = (dateStr: string) =>  new Date(dateStr);

const toRequredFormat = (num: number|null|undefined) => ('0' + num??0).slice(-2);

const adjustStatusToActiveStepId = (status: number) => status < CalloutStatuses.dispatchedToTeam? CalloutStatuses.dispatchedToTeam: status;
 
const preapreTimeAgo  = (dateParam: string|Date): string =>{
    if(!dateParam)
        return '';

    const date =  isDate(dateParam)? dateParam as Date : convertToDate(dateParam as string); 

    const duration = intervalToDuration({
        start: date,
        end: new Date()
      });
      let hours = duration.hours??0;
      let hoursAndDays = 0;
      if(duration.days){
        hoursAndDays = 24*duration.days;
      }
      hours = ((hours + hoursAndDays) > 99)? 99 : (hours + hoursAndDays);
    return `${toRequredFormat(hours)}:${toRequredFormat(duration.minutes)}:${toRequredFormat(duration.seconds)}`;
}

const preapreETA  = (seconds: number): string =>{
  if(!seconds)
      return '00:00';
  const curDate = new Date();

  const duration = intervalToDuration({
      start: curDate,
      end: addSeconds(curDate, seconds)
    });
    if(duration.hours){
      return '> 1 hour';
    }
  return `${toRequredFormat(duration.minutes)}:${toRequredFormat(duration.seconds)}`;
}

const prepareSteps = (calloutEvents: IRequestCalloutEventDTO[]): ICalloutRequestedStep[] =>{
    const steps = createCalloutSteps();
    if(calloutEvents.length === 0) 
        return steps;
    for (const step of steps) {
        const stepEvents = calloutEvents.filter(el => adjustStatusToActiveStepId(el.status) === step.id && !el.deleted);
        if(stepEvents.length === 0) 
            continue;
        const firstCreationDate = min(stepEvents.map(el => convertToDate(el.createdOn))); 
        step.createdOn = firstCreationDate;
        step.timeAgo = preapreTimeAgo(firstCreationDate);
    }

    return steps;
}

const getCoordDist = (lat1: number, lon1: number, lat2: number, lon2: number) => {
    var p = 0.017453292519943295;
    var c = Math.cos;
    var a = 0.5 - c((lat2 - lat1) * p) / 2 + (c(lat1 * p) * c(lat2 * p) * (1 - c((lon2 - lon1) * p))) / 2;
  
    return 12742 * Math.asin(Math.sqrt(a));
  };
  
  const getMaxDistance = (coords: IVehicleLocation[]) => {
    let maxDistance = 0;
    for (let i = 0; i < coords.length; i++) {
      for (let j = i+1; j < coords.length; j++) {
        const { latitude: lat1, longitude: lon1 } = coords[i];
        const { latitude: lat2, longitude: lon2 } = coords[j];
        const currentDistance = getCoordDist(lat1/1000000, lon1/1000000, lat2/1000000, lon2/1000000);
        if(currentDistance > maxDistance){
          maxDistance = currentDistance;
        }
      }
    }
    return maxDistance;
  }

export {
    prepareSteps,
    getMaxDistance,
    adjustStatusToActiveStepId,
    preapreETA,
    preapreTimeAgo
};